import { MaskLines, SectionLabel } from "@/components/Motion";
import { motion } from "framer-motion";

export const PageHeader = ({ label, titleLines, sub }) => (
  <section data-testid="page-header" className="relative overflow-hidden px-5 pt-36 pb-16 md:px-10 md:pt-48 md:pb-24">
    <div className="pointer-events-none absolute -right-20 -top-20 h-96 w-96 rounded-full bg-amber/10 blur-[120px]" />
    <div className="mx-auto max-w-[1400px]">
      <SectionLabel>{label}</SectionLabel>
      <h1 className="mt-6 font-head text-[15vw] font-medium leading-[0.85] tracking-tight text-white md:text-[9rem]">
        <MaskLines lines={titleLines} delay={0.1} />
      </h1>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.7 }}
          className="mt-8 max-w-xl text-lg leading-relaxed text-white/60"
        >
          {sub}
        </motion.p>
      )}
    </div>
  </section>
);
